<template>
  <div id="home">
    <br />
    <Table
      style="font-size: 20px"
      :content="self"
      border
      stripe
      :columns="columns1"
      :data="data1"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          style="background: red; border-color: red"
          type="error"
          size="small"
          @click="
            modal1 = true;
            upData = row;
            amend();
          "
          >修改</Button
        >
        <Button
          style="background: red; border-color: red; margin-left: 10px"
          type="error"
          size="small"
          @click="
            Delete = true;
            upData = row;
          "
          >删除</Button
        >
      </template>
    </Table>
    <Modal
      v-model="Delete"
      title="删除产品链接及接口参数"
      @on-ok="deleteUser()"
    >
      <div style="width: 100%; text-align: center">删除产品链接及接口参数</div>
    </Modal>
    <Modal
      width="40"
      v-model="modal1"
      title="修改产品链接及接口参数"
      @on-ok="ok()"
    >
      链接地址：
      <Input
        v-if="data1.length != 0"
        v-model="upData.url"
        style="width: 370px; margin-right: 15px"
      />
      <br />
      <br />接口请求参数 (json):
      <Input
        v-if="data1.length != 0"
        v-model="upData.requestData"
        style="width: 370px; margin-right: 15px"
      />
      <br />
      <br />权重:
      <Input
        type="number"
        v-if="data1.length != 0"
        v-model="upData.weight"
        style="width: 100px; margin-right: 15px"
      />
      <br />
      <br />三方渠道编码:
      <Input
        type="text"
        v-if="data1.length != 0"
        v-model="upData.t3rdCode"
        style="width: 100px; margin-right: 15px"
      />
      <br />
      <br />请求头:
      <Input
        type="text"
        v-if="data1.length != 0"
        v-model="upData.requestHeader"
        style="width: 100px; margin-right: 15px"
      />
      <br />
      <br />请求方式:
      <Input
        type="text"
        v-if="data1.length != 0"
        v-model="upData.requestMethod"
        style="width: 100px; margin-right: 15px"
      />
      <br />
      <br />状态:
      <Select
        v-if="data1.length != 0"
        v-model="upData.state"
        style="width: 200px; margin-left: 20px"
        placeholder="选择状态"
      >
        <Option v-for="item in types" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
    </Modal>
    <Page
      style="margin-top: 10px"
      :total="total"
      @on-change="pagingSuery"
      show-elevator
    />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "ProductUrl",
  data() {
    return {
      upData: {},
      treeData: [],
      dataIndex: 0,
      self: this,
      total: 0,
      Delete: false,
      productId: "",
      modal1: false,
      keyword: "",
      pageNow: 0,
      types: [
        {
          value: 0,
          label: "未使用",
        },
        {
          value: 1,
          label: "使用",
        },
      ],
      columns1: [
        {
          title: "产品ID",
          align: "center",
          key: "productId",
        },
        {
          title: "三方渠道编码",
          align: "center",
          key: "t3rdCode",
        },

        {
          title: "链接地址",
          align: "center",
          key: "url",
        },
        {
          title: "链接状态",
          align: "center",
          key: "stateText",
        },
        {
          title: "权重",
          align: "center",
          key: "weight",
        },

        {
          title: "请求头",
          align: "center",
          key: "requestHeader",
        },
        {
          title: "请求方式",
          align: "center",
          key: "requestMethod",
        },

        {
          title: "创建时间",
          align: "center",
          key: "createTime",
        },
        {
          title: "接口请求参数 json",
          align: "center",
          key: "requestData",
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "action",
        },
      ],
      data1: [{}],
    };
  },
  mounted: function () {
    this.getData();
  },
  activated: function () {
    this.getData();
  },

  methods: {
    ok() {
      api
        .UpdateProductUrl(
          this.upData
          //   {
          //   id: this.upData.id,
          //   productId: this.upData.productId,
          //   url: this.upData.url,
          //   state: this.upData.state,
          //   requestData: this.upData.requestData,
          //   weight: this.upData.weight,
          //   t3rdCode: this.upData.t3rdCode,
          // }
        )
        .then((data) => {
          this.getData();
        });
    },
    amend() {
      api.GetProductUrlId(this.upData.id).then((res) => {
        this.upData = res.body.data;
        this.$forceUpdate();
      });
    },

    deleteUser() {
      api.DelProductUrl({ id: this.upData.id }).then((data) => {
        this.getData();
      });
    },

    getData() {
      api
        .GetAllProductUrl({
          pageNow: this.pageNow,
          pageSize: "10",
          productId: this.$route.query.id,
        })
        .then((res) => {
          if (res.body.data) {
            this.total = res.body.data.total;
            this.data1 = res.body.data.list;
            this.data1.forEach((element) => {
              if (element.state === 0) {
                element.stateText = "未使用";
              } else {
                element.stateText = "使用";
              }
            });
          } else {
            this.total = 0;
            this.data1 = [];
          }
        });
    },
    changeInput() {
      this.pageNow = 0;
      this.getData();
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    },
  },
};

// GetRewardTotal
</script>

<style scoped lang = 'less' >
#home {
  height: 100%;
}
</style>